import { FORMS_WIDGET_TYPE } from '../../constants/reentry-planning.constants';
import { readFormsWidgetFormIds } from './formsWidgetConfig.util';

export const isFormsWidget = (widget) => widget?.widgetType === FORMS_WIDGET_TYPE;

/**
 * Maps API forms config to Forms WidgetBody props.
 * Defaults to readOnly; editable views attach callbacks via attachEditCallbacks.
 */
export const mapFormsWidgetProps = (widget) => ({
  formIds: readFormsWidgetFormIds(widget?.config),
  forms: [],
  readOnly: true,
});

/**
 * Enables Add Form / Remove for one editable Forms widget.
 *
 * @param {object} widget - Mapped UI widget (`type` / `id` / `props`)
 * @param {{ onAddForm: Function, onRemoveForm: Function }} handlers - From useFormsWidgetMutations
 */
export const attachFormsEditCallbacks = (widget, handlers) => ({
  ...widget,
  props: {
    ...widget.props,
    readOnly: false,
    onAddForm: () => handlers.onAddForm(widget.id),
    onRemoveForm: (formId) => handlers.onRemoveForm(widget.id, formId),
  },
});

export const formsWidgetFactory = {
  matches: isFormsWidget,
  type: FORMS_WIDGET_TYPE,
  mapProps: mapFormsWidgetProps,
  attachEditCallbacks: attachFormsEditCallbacks,
};
